import { render } from "./MockList.vue?vue&type=template&id=ac8a0a3a&scoped=true"
import script from "./MockList.vue?vue&type=script&lang=js"
export * from "./MockList.vue?vue&type=script&lang=js"

import "./MockList.vue?vue&type=style&index=0&id=ac8a0a3a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ac8a0a3a"]])

export default __exports__